<script>
	import { weatherStore, clearUpdate } from "$lib/utilities/weatherStore.js";
	import { onDestroy } from "svelte";

	import Weather from "$lib/components/Weather.svelte";

	$: selectedArea = $weatherStore.selectedArea;
	$: description = $weatherStore?.[selectedArea]?.description;
	$: temp = $weatherStore?.[selectedArea]?.temp;
	$: icon = $weatherStore?.[selectedArea]?.icon;
	$: locationName = $weatherStore?.[selectedArea]?.json?.name || selectedArea;
	$: country = $weatherStore?.[selectedArea]?.json?.sys?.country || "";
	$: feels_like = $weatherStore?.[selectedArea]?.json?.main?.feels_like || "";
	$: temp_min = $weatherStore?.[selectedArea]?.json?.main?.temp_min || "";
	$: temp_max = $weatherStore?.[selectedArea]?.json?.main?.temp_max || "";
	$: humidity = $weatherStore?.[selectedArea]?.json?.main?.humidity || "";
	$: pressure = $weatherStore?.[selectedArea]?.json?.main?.pressure || "";
	$: visibility = $weatherStore?.[selectedArea]?.json?.visibility || "";
	$: speed = $weatherStore?.[selectedArea]?.json?.wind?.speed || "";
	$: deg = $weatherStore?.[selectedArea]?.json?.wind?.deg || "";
	$: updatedAt = $weatherStore?.[selectedArea]?.updatedAt || "";

	$: details = `
    ${locationName}, ${country}
    ${description}
    Temp: ${temp}°F (feels like ${feels_like}°F)
    Min/Max: ${temp_min}°F / ${temp_max}°F
    Humidity: ${humidity}%
    Pressure: ${pressure} hPa
    Wind: ${((speed * 60 * 60) / 1609.34).toFixed(2)} m/h from ${deg}°
    Visibility: ${(visibility / 1609.34).toFixed(2)} mi
    Updated: ${new Date(updatedAt).toLocaleTimeString()}
  `;

	onDestroy(clearUpdate);

	// let updateTimeout;
	// $: (() => {
	//     if (updateTimeout) {
	//         clearTimeout(updateTimeout);
	//     }

	//     if (area) {
	//         updateTimeout = setTimeout(async () => {
	//             await getWeather(area);
	//         }, 1000);
	//     }
	// })();
</script>

<Weather {icon} {temp} {description} {details} />
